module.exports = __webpack_public_path__ + "static/media/qrcode.e4affdbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/qrcode.jpg
// module id = 195
// module chunks = 0